<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3">
<h1 class="tochead"><span class="bold">CONTENTS</span></h1>
</a><h2 class="toc"><a id="page_3"></a><a href="#/xhtml/06_Timeline">Timeline</a></h2>
<h2 class="toc"><a href="#/xhtml/07_Introduction">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/08_Chapter01">1. Custodians of Zion</a></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample">2. The Hebrew Soldier</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">3. Truce and Revolt</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">4. Smite the Enemy Hard</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">5. An Eye for an Eye</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample">6. Arms Not Votes</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Sources" title="Link target outside of Sample">Sources</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4953a437